import React, { useState } from 'react'
import LoanSummary from "./LoanSigning/LoanSummary"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { DateFormat, CurrencyFormat, PercentFormat, formatApr } from '../../../helpers/formatting'
import { useRequest } from '../../../hooks/UseRequest'
import { setNotification } from '../../../redux/notificationSlice'
import { selectPortfolios } from '../../../redux/portfolioSlice'

import { useDispatch, useSelector } from 'react-redux'

export default function VerificationLoanSigning(props) {
  const { customerData, loanData, setStep, paymentScheduleData, dropdownOptions, completeVerification } = props
  const requests = useRequest()
  const dispatch = useDispatch()
  const interestAmount = +paymentScheduleData.payment_schedule.schedule[0].payment - +paymentScheduleData.payment_schedule.schedule[0].principal_amount
  const portfolios = useSelector(selectPortfolios);

  const [termsAgreement, setTermsAgreement] = useState(false)
  const customerPortfolio = portfolios.data.find((p) => p.id === customerData.portfolio_id).code_key;

  const returnToPaymentSchedule = async () => {
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/manual_verification/${customerData?.id}/cancel_signature`)

    try {
      const response = await requests.delete()
      if (response.status === 200 || response.status === 201) {
        dispatch(setNotification({ type: 'success', body: '' }))
        setStep('payment_schedule')
      } else {
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      dispatch(setNotification({ type: 'error', body: error.response?.data?.message }))
    }
  }

  return loanData && (
    <div id="step3" className="loan-signing-container">
      <div className="app-card">
        <h2 data-ui-test="title-1" className="title agreement-title">
          Please review and sign your Loan Agreement
        </h2>
        <div>
          <p className="loan-agreement-text">
            Please take a moment to review the <a>Loan Agreement</a> and <a>Terms of your Loan </a>carefully.
            You will be required to electronically sign and date it. You will also
            electronically sign and date the disbursement and payment choice authorizations.
          </p>
          <LoanSummary customerData={customerData} loanSummary={loanData} classes="my-3" />
          <div>
            <form className="main-form-wrap ">
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I acknowledge that I have read and agree to the <a>Consent to Electronic
                      Communications</a> (the “CONSENT“), and I agree to receive electronic communications from
                    Development. <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
              {customerPortfolio === "LLL" ? (
                <div className="checkbox-input columns mt-4 pl-4">
                  <span className="checkbox pt-1">
                    <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                  </span>
                  <div className="label ml-3">
                    <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                      By checking this box, I acknowledge and agree to the Governing Law clause available <a>here.</a>
                    </label>
                  </div>
                </div>
              ) : null}
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I agree to receive funds according to the terms in the <a>Disbursement
                      Authorization</a>
                    (the &quot;AUTHORIZATION&quot;). <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I authorize electronic fund transfer payments from My Bank Account, via the
                    <a>Payment Choice Authorization.</a>
                    (Please note, you are not required to authorize this Payment Choice Authorization option in
                    order to be approved for a Loan).
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I consent to the <a>Dispute Resolution and Arbitration Procedure</a>.
                    <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I affirm that I am not a <a>member of the military</a>, nor am I a dependent
                    or spouse of any member of the military.
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I expressly <a>Consent to be Contacted by {loanData.name}</a>, its agents,
                    affiliates or anyone calling on its behalf at {loanData.phone}, by use of text
                    messages and auto-dialed and/or pre-recorded calls, for any and all purposes arising out of or
                    relating to my application, Loan and/or account or for any marketing or advertising
                    purposes. I understand that my consent is not required to obtain a Loan and that I may opt-out at
                    any time.
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I agree to the promotional terms available&nbsp;
                    <a>HERE</a>&nbsp;,
                    and acknowledge that if I do not abide by the promotional terms, the promotion will be
                    automatically
                    revoked and I will remain obligated under the terms of my loan agreement.
                    <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I agree that I have opened and read the
                    <span className="loan-upper">Loan Agreement</span>, the CONSENT and the AUTHORIZATION
                    and understand all of the terms of this Loan. <a>Click here</a> to review the terms of your
                    <span className="loan-upper">Loan Agreement</span>, the CONSENT and the AUTHORIZATION.
                    <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
            </form>
            <div className="notice-name--wrapper">
              <div className="notice checkbox-text">
                By typing your name and clicking the &quot;Sign Loan Agreement&quot; button below, you are
                electronically signing the <span className="loan-upper">Loan Agreement</span>, the
                CONSENT and the AUTHORIZATION and agreeing to all of the terms of this Loan. You
                are also acknowledging that you have read the entire&nbsp;
                <span className="loan-upper">Loan Agreement</span>, CONSENT and AUTHORIZATION and
                have the ability to download or print a fully completed copy of this&nbsp;
                Loan Agreement for your records. <a> Click here </a> to review the terms of your
                <span className="loan-upper">Loan Agreement</span>, the CONSENT and the AUTHORIZATION.
              </div>
            </div>
            <div className="notice-input--wrapper field text-input mt-6">
              <div className="field text-input mb-0">
                <div className="label">
                  <label
                    className="has-text-primary is-size-6 mb-2 mt-4"
                    id="field--ssp-name-on-card-id-label"
                    htmlFor="field--ssp-name-on-card-id"
                  >
                    Please type your name exactly as it appears on your application.
                    <span className="has-text-danger"> *</span>
                  </label>
                </div>
                <div className="field text-input">
                  <div className="control null">
                    <input name="full_name" className="input undefined undefined" value="" disabled />
                  </div>
                </div>
              </div>
            </div>
            <p className="is-size-6 has-text-weight-bold">{customerData?.first_name} {customerData?.last_name} </p>
            {loanData.risk_based_pricing_notice && (
              <p className="notice">
                Click <a>here</a> to view your Risk-Based Pricing Notice.
              </p>
            )}
            <div className="step-actions my-5 has-text-centered">
              <button type="submit" className="button is-primary py-3" disabled>
                <span className="mx-3"> Sign Loan Agreement </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <nav className="panel">
        <p className="panel-heading">Agent Acknowledgement</p>
        <div className="container p-2">
          <div className="columns">
            <div className="column is-full">
              <div className="field">
                <div className="control">
                  <label className="checkbox">
                    <input type="checkbox" onClick={() => setTermsAgreement(!termsAgreement)} /> I have read the Terms & Conditions to the Customer <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="columns pt-2 mb-0">
            <div className="column is-half">
              Loan Amount: <CurrencyFormat value={+loanData.principal_amount} />
            </div>
            <div className="column is-half">
              Bank Account Number: ######{customerData?.bank_account_number}
            </div>
          </div>
          <div className="columns">
            <div className="column is-half">
              APR: {formatApr(loanData.apr)}%
            </div>
            <div className="column is-half">
              Pay in Full on First Payment Date: <CurrencyFormat value={+loanData.principal_amount + interestAmount} />
            </div>
          </div>

          <div className="columns">
            <div className="column is-full">
              <p>First Payment Details:</p>

              <div>
                {paymentScheduleData?.payment_schedule && (
                  <div className="table-container mb-0 position-relative">
                    <table
                      className="lox-hooktable-table table is-bordered is-striped is-narrow is-hoverable is-fullwidth is-grey mb-3"
                    >
                      <thead>
                        <tr>
                          <th className="is-selected has-text-centered lox-payment-schedule-color">Date</th>
                          <th className="is-selected has-text-centered lox-payment-schedule-color">Pay Method</th>
                          <th className="is-selected has-text-centered lox-payment-schedule-color">Principal $</th>
                          <th className="is-selected has-text-centered lox-payment-schedule-color">Interest $</th>
                          {/* TODO: the following logic will be changed */}
                          {paymentScheduleData.payment_schedule.schedule[0].scheduled_loan_fee > 0 ? (
                            <th className="is-selected has-text-centered lox-payment-schedule-color">Loan Fee $$$</th>
                          ) : null}
                          <th className="is-selected has-text-centered lox-payment-schedule-color">Total $$$</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paymentScheduleData?.payment_schedule.schedule[0] ? (
                          <tr>
                            <td className="has-text-centered" style={{ whiteSpace: 'nowrap' }}>
                              <DateFormat dateString={paymentScheduleData.payment_schedule.schedule[0].date} />
                            </td>
                            <td className="has-text-centered" style={{ whiteSpace: 'nowrap' }}>
                              {dropdownOptions.find((option) => option?.id === paymentScheduleData?.payment_method_dropdown_option_id)?.name}
                            </td>
                            <td className="has-text-centered" style={{ whiteSpace: 'nowrap' }}>
                              <CurrencyFormat value={+paymentScheduleData.payment_schedule.schedule[0].principal_amount} />
                            </td>
                            <td className="has-text-centered" style={{ whiteSpace: 'nowrap' }}>
                              <CurrencyFormat value={interestAmount} />
                            </td>
                            {/* TODO: the following logic will be changed */}
                            {paymentScheduleData.payment_schedule.schedule[0].scheduled_loan_fee > 0 ? (
                              <td className="has-text-centered" style={{ whiteSpace: 'nowrap' }}>
                                <CurrencyFormat value={+paymentScheduleData.payment_schedule.schedule[0].scheduled_loan_fee} />
                              </td>
                            ) : null}
                            <td className="has-text-centered" style={{ whiteSpace: 'nowrap' }}>
                              <CurrencyFormat value={+paymentScheduleData.payment_schedule.schedule[0].payment} />
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="columns">
            <div className="column is-full is-flex is-justify-content-end">
              <button
                className="button is-link is-small"
                type="button"
                disabled={!termsAgreement}
                onClick={completeVerification}
              >
                <span className="mx-2">
                  Verification Completed
                  <span
                    className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-top has-tooltip-primary has-text-weight-normal`}
                    data-tooltip={`Completing verifications will only stop the verification process for the Agent. The customer is not complete until they have signed the loan agreement. You should not click this button until the call has ended with the customer.`}
                  >
                    <FontAwesomeIcon icon={faCircleInfo} className={`pl-1`} />
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="column is-flex is-align-items-end p-0 mb-3">
        <button
          className="button has-background-grey has-text-light is-small"
          type="button"
          onClick={returnToPaymentSchedule}
        >
          <span className="mx-2">
            {"<- Back"}
            <span
              className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-top has-tooltip-primary has-text-weight-normal`}
              data-tooltip={`Warning! Returning to payment schedule will mark this signature attempt as invalid and the customer will not be able to proceed until you resend the loan agreement.`}
            >
              <FontAwesomeIcon icon={faCircleInfo} className={`pl-1`} />
            </span>
          </span>
        </button>
        <p className="has-text-danger ml-2">Going back will block the customer from signing the agreement.</p>
      </div>
    </div>
  )
}
